import { ref, readonly } from 'vue'
import { apiClient } from '../services/apiClient'

const _roomId = ref<string>('')
const _roomNumber = ref<string>('Unknown')

function init(): void {
  console.log('[useRoomId] Initializing...')
  const urlParams = new URLSearchParams(window.location.search)
  const roomParam = urlParams.get('room')
  const storedRoomId = localStorage.getItem('virtualcare-room-id')
  console.log('[useRoomId] URL room param:', roomParam, 'Stored roomId:', storedRoomId)

  let roomId: string

  if (roomParam) {
    roomId = roomParam.startsWith('room-') ? roomParam : `room-${roomParam}`
    localStorage.setItem('virtualcare-room-id', roomId)
  } else if (storedRoomId) {
    roomId = storedRoomId
  } else {
    console.error('[useRoomId] No room ID configured. Provide via URL: ?room=302')
    roomId = 'room-unknown'
  }

  _roomId.value = roomId
  _roomNumber.value = roomId.replace('room-', '')
  apiClient.setRoomId(roomId)
  console.log('[useRoomId] Initialized with roomId:', roomId, 'roomNumber:', _roomNumber.value)
}

init()

export function useRoomId() {
  return {
    roomId: readonly(_roomId),
    roomNumber: readonly(_roomNumber),
  }
}
